module.exports = __webpack_public_path__ + "img/rome_background_hero.21791999.png";